"use strict";

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.OperatingSystem = void 0;
var _requester = require("../requester"),
  _types = require("./types"),
  _types2 = require("../types");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var OperatingSystem = /*#__PURE__*/function () {
  function OperatingSystem(a) {
    _classCallCheck(this, OperatingSystem);
    _defineProperty(this, "operatingSystem", void 0), _defineProperty(this, "status", void 0), this.operatingSystem = a, this.status = _types2.TrackingStatus.Unsent;
  }
  return _createClass(OperatingSystem, [{
    key: "url",
    get: function get() {
      return this.operatingSystem ? _requester.UrlEventType.StaticData + _requester.UrlParameter.Os + this.operatingSystem + _requester.UrlParameter.OsIndex + _types.OperatingSystemIndexMap[this.operatingSystem] : "";
    }
  }, {
    key: "data",
    get: function get() {
      return {
        operatingSystem: this.operatingSystem,
        type: _types.KameleoonData.OperatingSystem,
        status: this.status
      };
    }
  }], [{
    key: "_fromRaw",
    value: function _fromRaw(a) {
      var b = a.operatingSystem,
        c = a.status,
        d = new OperatingSystem(b);
      return d.status = c, d;
    }
  }, {
    key: "_fromVisit",
    value: function _fromVisit(a) {
      if (a.staticDataEvent) {
        var _a$staticDataEvent$da = a.staticDataEvent.data,
          b = _a$staticDataEvent$da.os,
          c = _a$staticDataEvent$da.osIndex;
        if (b || "number" == typeof c) {
          var _a = null !== b && void 0 !== b ? b : _types.OperatingSystemTypeMap[c];
          return new OperatingSystem(_a);
        }
      }
    }
  }]);
}();
exports.OperatingSystem = OperatingSystem;